import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { BASE_ROTAS } from './lib/idiomaUrl'
import { HelmetProvider } from 'react-helmet-async'
import './config/version'
import './lib/runtimePlatform'
import './lib/colunaApp'
import { iniciarPainelColeta } from './lib/painelColeta'
import { iniciarConferenciaDeVersao } from './lib/versaoNova'
import { LanguageProvider } from './context/LanguageProvider'
import { ReaderProvider } from './context/ReaderContext'
import { AuthProvider } from './context/AuthContext'
import { DixProvider } from './context/DixContext'
import { AchievementsProvider } from './context/AchievementsContext'
import { TutorialProgressProvider } from './context/TutorialProgressContext'
import { EventosProvider } from './context/EventosContext'
import { RadioNinaProvider } from './components/RadioNina/RadioNinaContext'
import App from './App'
import './index.css'

iniciarPainelColeta()
iniciarConferenciaDeVersao()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ReaderProvider>
      <HelmetProvider>
        <BrowserRouter basename={BASE_ROTAS}>
          <AuthProvider>
              <DixProvider>
                <AchievementsProvider>
                  <TutorialProgressProvider>
                    <EventosProvider>
                      <LanguageProvider>
                        <RadioNinaProvider>
                          <App />
                        </RadioNinaProvider>
                      </LanguageProvider>
                    </EventosProvider>
                  </TutorialProgressProvider>
                </AchievementsProvider>
              </DixProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ReaderProvider>
  </React.StrictMode>,
)
